import { render, staticRenderFns } from "./ToggleOptionSurvey.vue?vue&type=template&id=01b52fb8"
import script from "./ToggleOptionSurvey.vue?vue&type=script&lang=js"
export * from "./ToggleOptionSurvey.vue?vue&type=script&lang=js"
import style0 from "./ToggleOptionSurvey.vue?vue&type=style&index=0&id=01b52fb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports